'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithSmallWindowDetected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _WindowQuery = require('./WindowQuery');

var _WindowQuery2 = _interopRequireDefault(_WindowQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithSmallWindowDetected = exports.WithSmallWindowDetected = function (_Component) {
  _inherits(WithSmallWindowDetected, _Component);

  function WithSmallWindowDetected() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithSmallWindowDetected);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithSmallWindowDetected.__proto__ || Object.getPrototypeOf(WithSmallWindowDetected)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      smallWindowDetected: false
    }, _this.onResizeWindow = function (_ref2) {
      var windowWidth = _ref2.windowWidth;

      _this.updateSmallWindowDetected(windowWidth);
    }, _this.updateSmallWindowDetected = function (windowWidth) {
      var autoCollapseLeftNavPx = _this.props.theme.dimensions.autoCollapseLeftNavPx;


      _this.setState({ smallWindowDetected: windowWidth < autoCollapseLeftNavPx });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithSmallWindowDetected, [{
    key: 'componentDidMount',


    /**
     * On initial mount, update smallWindowDetected state based on window size.
     * @return {undefined} This method is expected to trigger a state mutation, not return a value.
     */
    value: function componentDidMount() {
      this.updateSmallWindowDetected(window.innerWidth);
    }

    /**
     * event handler for resizing the window
     * @param  {number} windowWidth  The width of the window after resizing.
     * @return {undefined} This method is expected to mutate state, not return a value.
     */


    /**
     * Sets a new value for this.state.smallWindowDetected based on the current window width
     * @param  {number} windowWidth  The width of the window to be used in determining the
     *                               smallWindowDetected state
     * @return {undefined} This method is expected to mutate state, not return a value.
     */

  }, {
    key: 'render',
    value: function render() {
      var passThroughProps = (0, _lodash.omit)(this.props, ['render', 'theme']);

      return _react2.default.createElement(
        _WindowQuery2.default,
        { onResize: this.onResizeWindow },
        this.props.render(_extends({
          smallWindowDetected: this.state.smallWindowDetected
        }, passThroughProps))
      );
    }
  }]);

  return WithSmallWindowDetected;
}(_react.Component);

/* istanbul ignore next */


WithSmallWindowDetected.propTypes = {
  render: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.shape({
    dimensions: _propTypes2.default.shape({
      autoCollapseLeftNavPx: _propTypes2.default.number.isRequired
    }).isRequired
  }).isRequired
};
var withSmallWindowDetected = function withSmallWindowDetected(WrappedComponent) {
  function RenderPropComponent(props) {
    return _react2.default.createElement(WithSmallWindowDetected, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  }

  return (0, _styledComponents.withTheme)(RenderPropComponent);
};

exports.default = withSmallWindowDetected;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/withSmallWindowDetected.js
// module id = 1677
// module chunks = 2